import script from "./ModalRooming.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalRooming.vue?vue&type=script&setup=true&lang=js"

import "./ModalRooming.vue?vue&type=style&index=0&id=ddc4a7a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc4a7a4"]])

export default __exports__